/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminReportsEditCtrl", ["$scope", "$location", "Utils", "entity", "mode", "$uibModal", "AdminReportsService", "toastr", function ($scope, $location, Utils, entity, mode, $uibModal, AdminReportsService, toastr) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			entity: entity.data,
			mode: mode
		};

		var deleteEntityModal;


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/

		/**
             * Ouvrir la modal de suppression d'un client.
             */
		$scope.openDeleteModal = function (entity) {
			$scope.data.entityToDelete = entity;
			deleteEntityModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		$scope.deleteEntity = function (id) {
			AdminReportsService.deleteEntity(id)
				.then(() => {
					toastr.success("", "Rapport supprimé");
					$location.path("/admin/reports");
					deleteEntityModal.close();
				})
				.catch((response) => {
					toastr.error(response.data.message, "Problème lors de la suppression du rapport");
				});
                
		};
        


		/**
             * Modifier ou ajouter une entité sur le serveur.
             */
		$scope.post = function () {

			if ($scope.data.mode === "new") {

				AdminReportsService.addEntity($scope.data.entity).then((response) => {
					toastr.success("", "Rapport " + response.data.name + " créé");
					$location.path("/admin/reports");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la création du rapport. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				AdminReportsService.editEntity($scope.data.entity).then((response) => {
					toastr.success("", "Rapport " + response.data.name + " mis à jour");
					$scope.data.company = response.data;
				}).catch((response) => {
					const data = response.data;
					var errorMessage = "Problème lors de la mise à jour du rapport. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};


	}]
	)
;